"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _DefaultModal = _interopRequireDefault(require("Modals/DefaultModal.jsx"));
var _TextFile = _interopRequireDefault(require("Icons/TextFile"));
var _Picture = _interopRequireDefault(require("Icons/Picture"));
var _PDFFile = _interopRequireDefault(require("Icons/PDFFile"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
const FileItem = props => {
  var _file$files, _file$files$map;
  const userLogin = window.app.state.session.user.login;
  const userRole = window.app.state.session.user.roles[0];
  const [deleteModal, setDeleteModal] = (0, _react.useState)();
  const [deleting, setDeleting] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)(null);
  const {
    file
  } = props;
  const fileType = file.files[0].type;
  const Icon = fileType === "application" ? _TextFile.default : fileType === "pdf" ? _PDFFile.default : fileType === "image" ? _Picture.default : _TextFile.default;
  const deleteFile = async () => {
    if (deleting === true) return;
    setDeleting(true);
    try {
      var response = await (0, _ajaxRequest.default)((0, _Routing.action)('deleteFile'), {
        data: {
          message_date: props.messageDate
        }
      });
    } catch (e) {
      return setDeleting(false);
    }
    props.handleFilesList(response.data);
    app.emit({
      event: 'requestChatRefresh'
    });
    setDeleting(false);
  };
  const deleting_loader = deleting === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['white', 'bg-red']
  }) : undefined;
  const footer_del_btn = /*#__PURE__*/_react.default.createElement("button", {
    role: "button",
    "aria-label": "Fermer",
    className: 'c-flat-btn c-flat-btn--red u-margin-right-30',
    onClick: deleteFile
  }, "Supprimer d\xE9finitivement", deleting_loader);
  const fileSentBy = file.sent_by;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "file_item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "file_item__sentBy"
  }, "Envoy\xE9 par ", file.sent_by, " le ", (0, _moment.default)(file.message_date).format('Do MMMM [à] HH:mm')), file === null || file === void 0 ? void 0 : (_file$files = file.files) === null || _file$files === void 0 ? void 0 : (_file$files$map = _file$files.map) === null || _file$files$map === void 0 ? void 0 : _file$files$map.call(_file$files, file => /*#__PURE__*/_react.default.createElement("div", {
    key: file.id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "file_item__infos"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "file_item__link",
    href: file.url
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    className: "c-file-thumbnail__icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "file_item__size"
  }, " ", file.size_MB, "Mo "), userRole === "ortho" ? undefined : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "file_item__filename"
  }, file.filename, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: "file_item__title"
  }, file.title, " "))), userRole === fileSentBy || userLogin === fileSentBy ? /*#__PURE__*/_react.default.createElement("div", {
    className: "file_item__delete"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: e => setDeleteModal({
      open: true,
      src: e === null || e === void 0 ? void 0 : e.target
    })
  }, "Supprimer fichier")) : undefined)), /*#__PURE__*/_react.default.createElement(_DefaultModal.default, {
    open: deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.open,
    onClose: () => setDeleteModal({}),
    bemit: ["small"],
    "close-label": "Annuler",
    "action-buttons": footer_del_btn,
    trigger_src: deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.src,
    "close-ref": ref
  }, "Etes vous sur de vouloir supprimer le fichier ?"));
};
var _default = exports.default = FileItem;
